import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFireList } from 'angularfire2/database';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { NgProgress } from 'ngx-progressbar';
import { LogisticsService } from '../shared/logistics.service';
import { DateService } from 'app/date/date.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import * as firebase from 'firebase/app';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import { UserService } from 'app/users/shared/user.service';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor, orderBy, filterBy } from '@progress/kendo-data-query';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { SessionService } from 'app/sessions/session.service';
import { WorkbookSheet, Workbook, WorkbookSheetColumn, WorkbookSheetRow, WorkbookSheetRowCell } from '@progress/kendo-ooxml';
import { saveAs } from '@progress/kendo-file-saver';
export const search_id = {
  id: ""
};
export const form_date = {
  from : "",
  to: ""
};
export const curentPage = {
  page : 0
}
export const curentTab = {
  tab: "tab1"
}
declare var google;
@Component({
  selector: 'app-manage-shipment',
  templateUrl: './manage-shipment.component.html',
  styleUrls: ['./manage-shipment.component.css'],
  providers: [NotificationToastService, LogisticsService,DateService],
  animations: [fadeInOutTranslate],
})

export class ManageShipmentComponent implements OnInit {
  shipmentList: AngularFireList<any>;

  public sortOrder: string = "desc";
  public sortBy: string = "";
  public data: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  public deliveryBoys : any;
  public supervisors: any;
  public selectedPerson;
 
  searchSubmitted = false;
  searchResult:any = [];
  changeSupervisor: boolean = false;
  changeDB: boolean = false;
  rowId:any;
  status:number;
  branchList:any;
  branchArray:any;
  driversArray:any;
  isadmin:boolean;
  shipments:any;
  years:any;
  months:any;
  myForm:any;
  myFormMonth:any
  myFormSelect:any;
  myFormBranch:any;
  myFormDriver:any;
  myFormBranchTransfer:any;
  searchForm:any;
  selectedElement:any;
  user:any;
  submittedBranch: boolean = false;
  isAuto:boolean = false;
  selectedStatus:any = 0;
  users:any = [];
  shipmentData:any = [];
  assginees:any = [];
  public gridDataToPdf: any[];
  public gridDataToPdfExport: any[];
  @ViewChild('select') private selectModel;

  public gridView: GridDataResult;
  public pageSize = 10;
  public pageSizeExcel = 0;
  public skip = 0;
  public multiple = false;
  public allowUnsort = true;
  public sort: SortDescriptor[] = [{
    field: 'id',
    dir: 'desc'
  }];
  @ViewChild("tabRef") tabRef;
  constructor(private router:Router, private nf: NotificationToastService, private ngProgress: NgProgress, private logisticsService: LogisticsService, private dateService:DateService, private config: NgbDatepickerConfig, private us:UserService, private ss:SessionService) {
    this.initializeForms();
    config.minDate = {year:1890, month:1, day: 1};
    config.maxDate = {year: 2099, month: 12, day: 31};
    config.outsideDays = 'visible';
   }

  ngOnInit() {
    this.searchResult = [];
    this.getAllUsers();
    if(localStorage.getItem("courierapp_role") == "super admin")
    {
      this.isadmin = false;
    }
    else
    {
      this.isadmin = true;
    }
    this.getAllBranch();
    setTimeout(() => {
      this.getAllShipments();
    }, 1000);
    this.getAllDrivers();
    this.getDeliveryBoys(null);
    this.getSupervisors();
    this.checkSearchId();
    this.findDistance();
    this.load ();
    this.getYearsList();
    this.getMonthsList();
    this.getUserDetails();
    this.getSettings();
    this.tabRef.activeId = curentTab.tab;
  }
  initializeForms()
  {
    //by date
    let fromdate = new FormControl('', Validators.required);
    let todate = new FormControl('');
      this.myForm = new FormGroup({
        fromdate: fromdate,
        todate: todate
      });
    //by month
    let year = new FormControl('', Validators.required);
    let month = new FormControl('');
      this.myFormMonth = new FormGroup({
        year: year,
        month: month,
        assignee : new FormControl('Select Driver'),
        branch : new FormControl('Select Branch'),
        status : new FormControl('Select Status')
      });
      this.myFormMonth.reset();
      this.myFormSelect =  new FormGroup({
        selectFilter : new FormControl('1', Validators.required)
      });
      //branch form
      this.myFormBranch =  new FormGroup({
        branch : new FormControl('', Validators.required)
      });
      this.myFormDriver = new FormGroup({
        driver : new FormControl('Select Driver', Validators.required),
        branch : new FormControl('Select Branch', Validators.required)
      });
      this.myFormBranchTransfer = new FormGroup({
        fromBranch : new FormControl('Select Branch', Validators.required),
        toBranch : new FormControl('Select Branch', Validators.required)
      });

      this.searchForm = new FormGroup({
        fromdate: new FormControl(''),
        todate: new FormControl(''),
        assignee : new FormControl('Select Driver'),
        branch : new FormControl('Select Branch'),
        status : new FormControl('Select Status'),
        phone : new FormControl(''),
        fromBranch : new FormControl('Select Branch', Validators.required),
        toBranch : new FormControl('Select Branch', Validators.required)
      });
      this.searchForm.reset();

      this.myFormDriver.reset();
      this.myFormBranch.reset();
      this.myFormBranchTransfer.reset();
  }
  getYearsList()
  {
    this.years = [];
    for(let i=0;i<5;i++)
    {
      var y = 2018 + i;
      this.years.push(y);
    }
  }
  getMonthsList()
  {
    this.months = [
      {
        index: 1,
        month: "January"
      },
      {
        index: 2,
        month: "February"
      },
      {
        index: 3,
        month: "March"
      },
      {
        index: 4,
        month: "April"
      },
      {
        index: 5,
        month: "May"
      },
      {
        index: 6,
        month: "June"
      },
      {
        index: 7,
        month: "July"
      },
      {
        index: 8,
        month: "August"
      },
      {
        index: 9,
        month: "September"
      },
      {
        index: 10,
        month: "October"
      },
      {
        index: 11,
        month: "November"
      },
      {
        index: 12,
        month: "December"
      }
    ];

  }
  getAllShipments()
  {
    this.shipments = this.logisticsService.getShipments();
    this.shipments.snapshotChanges().subscribe(item=>{
      this.ngProgress.start();
      this.data = [];
      this.shipmentData = [];
      this.assginees = [];
      item.forEach(element =>{
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          //console.log("y",y);
          if(this.branchArray)
          {
            //console.log("branchArray",this.branchArray,element.payload.child("branch").val(),this.branchArray[element.payload.child("branch").val()].name);
            if(this.branchArray[element.payload.child("branch").val()] != null)
            {
              y["branchName"] = this.branchArray[element.payload.child("branch").val()]?this.branchArray[element.payload.child("branch").val()].name:"";
              y["branch"] = element.payload.child("branch").val();
            }
          }
          if(element.payload.child("items").val()!=null)
          {
            var items = element.payload.child("items").val();
            var itemList = [];
            for(let i in items)
            {
              itemList.push(items[i]);
            }
            y["itemList"] = itemList;
          }
          if(element.payload.child("transitHistory").val()!=null)
          {
            var transitHistory = element.payload.child("transitHistory").val();
            for(let i in transitHistory)
            {
              if(transitHistory[i].status == "Shipment Pickedup")
              y["pickedBy"] = transitHistory[i].userName;
            }
          }
          if(this.users)
          {
            if(element.payload.child("assignedTo").val())
            y["assignee"] = this.users[element.payload.child("assignedTo").val()];
            if(element.payload.child("assignedPerson").val())
            y["assignee"] = element.payload.child("assignedPerson").val();
          }
          y["statusText"] = this.getStatus(element.payload.child("status").val());
          y["pickupDate"] ="ASAP";
          if(element.payload.child("source/date").val())
          {
            var date = element.payload.child("source/date").val();
            y["pickupDate"] = date.day+"/"+date.month+"/"+date.year;
          }
          y["deliveryDate"] ="ASAP";
          if(element.payload.child("destination/date").val())
          {
            var date = element.payload.child("destination/date").val();
            y["deliveryDate"] = date.day+"/"+date.month+"/"+date.year;
          }
          this.data.push(y);
          this.shipmentData.push(y);
          if(y["assignee"] && !this.assginees.includes(y["assignee"]))
          {
            this.assginees.push(y["assignee"]);
          }
      });
      this.loadItems();
      this.ngProgress.done();
      this.restorePageOnSearch();
    });
  }
  getAllDrivers()
  {
    var drivers= this.logisticsService.getDrivers();
    drivers.snapshotChanges().subscribe(item=>{
      this.driversArray = [];
      item.forEach(element =>{
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          this.driversArray[element.key] = y;
      });
    });
  }
  getAllBranch()
  {
    var drivers= this.logisticsService.getBranch();
    drivers.snapshotChanges().subscribe(item=>{
      this.branchList = [];
      this.branchArray = [];
      item.forEach(element =>{
        var data = element.payload.toJSON();
        data["$key"] = element.key;
        this.branchList.push(data);
        this.branchArray[element.key] = data;
      });
    });
  }
   findDistance()
   {
    var latitude1 = 12.876784;
    var longitude1 = 74.848132;
    var latitude2 = 12.876030;
    var longitude2 = 74.842000;
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'address': "575002" }, (results, status) =>{
      if (status == google.maps.GeocoderStatus.OK) {
          latitude1 = results[0].geometry.location.lat();
          longitude1 = results[0].geometry.location.lng();
      } else {
          alert("Request failed.");
      }
     
  });
  geocoder.geocode({ 'address': "575003" }, (results, status) =>{
    if (status == google.maps.GeocoderStatus.OK) {
      latitude2 = results[0].geometry.location.lat();
      longitude2 = results[0].geometry.location.lng();
    } else {
        alert("Request failed.");
    }
   
});

setTimeout(() => {
  var distance = google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(latitude1, longitude1), new google.maps.LatLng(latitude2, longitude2));       
}, 1000);
    
   }
  checkSearchId()
  {
    if(search_id.id != "")
    {
      this.filterQuery = search_id.id;
    }
  }
  getDeliveryBoys(branch)
  {
    //console.log("on branch selected");
    var deliveryBoys= this.logisticsService.getDrivers();
    if(localStorage.getItem("courierapp_role") == "super admin")
    {
      deliveryBoys.snapshotChanges().subscribe(item=>{
        this.deliveryBoys = [];
        item.forEach(element =>{
          if(element.payload.child("status").val() == 1)
          {
            var y = element.payload.toJSON();
            y["$key"] = element.key;
            this.deliveryBoys.push(y);
          }
        });
      });
    }
    else
    {
      deliveryBoys.snapshotChanges().subscribe(item=>{
        this.deliveryBoys = [];
        item.forEach(element =>{
          if(element.payload.child("branch").val() == localStorage.getItem("branch"))
          {
          if(element.payload.child("status").val() == 1)
          {
            var y = element.payload.toJSON();
            y["$key"] = element.key;
            this.deliveryBoys.push(y);
          }
          }
        });
      });
    }
  }
  getSupervisors()
  {
    var supervisors= this.logisticsService.getSupervisors();
    if(localStorage.getItem("courierapp_role") == "super admin")
    {
    supervisors.snapshotChanges().subscribe(item=>{
      this.supervisors = [];
      item.forEach(element =>{
        if(element.payload.child("status").val() == 1)
          {
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          this.supervisors.push(y);
          }
      });
    });
  }
  else
  {
    supervisors.snapshotChanges().subscribe(item=>{
      this.supervisors = [];
      item.forEach(element =>{
        if(element.payload.child("branch").val() == localStorage.getItem("branch"))
        {
          if(element.payload.child("status").val() == 1)
          {
         var y = element.payload.toJSON();
          y["$key"] = element.key;
          this.supervisors.push(y);
          }
        }
      });
    });
  }
  }
  view(id)
  {
    search_id.id = this.filterQuery;
    this.router.navigate(['/view-shipment-details'], { queryParams : {key: id, from: 'shipment'}  });
  }
  delete(id)
  {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(() => {
      this.logisticsService.deleteShipment(id);
      swal({
        title:'Deleted!',
        text: 'Your file has been deleted.',
        type: 'success'
      })
    }).catch(swal.noop);
  }
  refresh()
  {
      this.sortBy = "";
      this.filterQuery = "";
      this.myForm.reset();
      form_date.from = "";
      form_date.to = "";
      curentPage.page = 0;
      this.skip = curentPage.page;
      this.filter = "1";
      this.myFormMonth.reset();
      this.myFormSelect.reset();
      this.myFormSelect.setControl("selectFilter",new FormControl("1"));
      this.myFormDriver.reset();
      //this.getAllShipments();
      this.data = this.shipmentData;
      this.searchResult = [];
      this.searchSubmitted = false;
      this.searchForm.reset();
      this.loadItems();
  }
  getSelectedDeliveryBoy(e,name)
  {
    this.selectedPerson = e.target.value;
  }
  assignDeliveryBoy(id,branch,status,role)
  {
    if(this.selectedPerson != null)
    {
      var date_time = this.dateService.getTimeandDate();
      this.logisticsService.assignDeliveryBoy(id,this.selectedPerson,branch, date_time.date, date_time.time,status,role);
      this.rowId = null;
      this.changeDB = false;
      this.selectedPerson = null;
  }
  else
  {
    this.rowId = null;
    this.changeDB = false;
  }
  }
  changeDeliveryBoy(id,branch)
  {
    this.changeDB = true;
    this.rowId = id;
  }

  getSelectedSupervisor(e,name)
  {
    this.selectedPerson = e.target.value;
  }

  changeSupervisorMethod(id,status)
  {
    this.changeSupervisor = true;
    this.rowId = id;
    this.status = status;
  }
  acceptOrder(id)
  {
    this.logisticsService.acceptOrder(id);
    this.rowId = null;
    this.changeSupervisor = false;
    this.nf.addToast({title:'Status Update', msg:'Order Accepted', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
  }
  declineOrder(id)
  {
    this.logisticsService.declineOrder(id);
    this.rowId = null;
    this.changeSupervisor = false;
    this.nf.addToast({title:'Status Update', msg:'Order Declined', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
  }
  timer(ms) {
  return new Promise(res => setTimeout(res, ms));
  }
  
  async load () {
    for (var i = 0; i < 3; i++) {
      //console.log(i);
      await this.timer(3000);
    }
  }
  invoice(id)
  {
    //window.open("http://paarseldev.com/invoice/"+id, '_blank');
    window.open("http://paarsel.com/invoice/"+id, '_blank');
  }
  assignDeliveryBoyForShipment(id,branch)
  {
    this.assignDeliveryBoy(id,branch,6,'driver');  
  }
  assignSupervisorForShipment(id,branch)
  {
    this.assignDeliveryBoy(id,branch,3,'supervisor');
  }
  isChangeBranch: boolean = false;
  selectedBranch:any;
  changeBranch(shipmentId,status)
  {
    if(status == 1 || status == 6 || status == 11)
    {
      this.isChangeBranch = true;
      this.rowIdBranch = shipmentId;
    }
    else
    {
      this.alertDialog();
      //alert("Branch can't be changed now");
    }
  }
  getSelectedBranch(e)
  {
    this.selectedBranch = e.target.value;
  }
  rowIdBranch:any;
  assignToBranch(shipmentId,branch,status)
  {
    if(this.selectedBranch != null && this.selectedBranch != branch)
    {
      this.logisticsService.assignToBranch(shipmentId, this.selectedBranch,status);
      this.selectedBranch = null;
      this.isChangeBranch = false;
      this.rowIdBranch = null;
    }
    else
    {
      this.rowIdBranch = null;
      this.isChangeBranch = false;
    }
  }
  onSubmit()
  {
    this.ngProgress.start();
    var from = this.myForm.value.fromdate;
    var to = this.myForm.value.todate;
    form_date.from = from;
    form_date.to = to;
    this.getSpecificDateShipment(from,to);
    this.searchSubmitted =  true;
  }
  getSpecificDateShipmentOld(from,to)
  {
    this.shipments.snapshotChanges().subscribe(item=>{
      this.ngProgress.start();
      this.data = [];
      item.forEach(element =>{
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          y["branchName"] = this.branchArray?this.branchArray[element.payload.child("branch").val()]?this.branchArray[element.payload.child("branch").val()].name:"":"";
          var fromDate = new Date(from.year+"/"+from.month+"/"+from.day);
          var toDate;
          if(to == '')
          {
            var date = new Date();
            toDate  = new Date(date.getFullYear()+"/"+(date.getMonth() + 1)+"/"+date.getDate());
          }
          else
          {
            toDate  = new Date(to.year+"/"+to.month+"/"+to.day);
          }
          while(fromDate <= toDate)
          {
          var currentDate = fromDate.getDate()+"/"+(fromDate.getMonth()+1) +"/"+fromDate.getFullYear();
          var shipment_date = element.payload.child("source").child("date").child("day").val()+"/"+element.payload.child("source").child("date").child("month").val()+"/"+element.payload.child("source").child("date").child("year").val();
          var shipment_date2 = element.payload.child("destination").child("date").child("day").val()+"/"+element.payload.child("destination").child("date").child("month").val()+"/"+element.payload.child("destination").child("date").child("year").val();
          if(currentDate == shipment_date || currentDate == shipment_date2)
            {
                if(!(this.data.includes(y)))
                {
                  this.data.push(y);
                }
            }
            fromDate.setDate(fromDate.getDate() + 1);
          }
        });
        this.searchResult = this.data;
        this.loadItems();
    this.ngProgress.done();
    });
  }
  getSpecificDateShipment(from,to)
  {
      this.ngProgress.start();
      this.data = [];
      this.shipmentData.forEach(element =>{
        //console.log("element",element);
        var y = element;
          var fromDate = new Date(from.year+"/"+from.month+"/"+from.day);
          var toDate;
          if(to == '')
          {
            var date = new Date();
            toDate  = new Date(date.getFullYear()+"/"+(date.getMonth() + 1)+"/"+date.getDate());
          }
          else
          {
            toDate  = new Date(to.year+"/"+to.month+"/"+to.day);
          }
          while(fromDate <= toDate)
          {
          var currentDate = fromDate.getDate()+"/"+(fromDate.getMonth()+1) +"/"+fromDate.getFullYear();
          var shipment_date = element.source.date?element.source.date.day+"/"+element.source.date.month+"/"+element.source.date.year:"";
          var shipment_date2 = element.destination.date?element.destination.date.day+"/"+element.destination.date.month+"/"+element.destination.date.year:"";
          if(currentDate == shipment_date || currentDate == shipment_date2)
            {
                if(!(this.data.includes(y)))
                {
                  this.data.push(y);
                }
            }
            fromDate.setDate(fromDate.getDate() + 1);
          }
        });
        this.searchResult = this.data;
        this.loadItems();
    this.ngProgress.done();
  }
     filter:String = "1";
     onFilterSelected(event)
     {
      this.filter = event.target.value;
     }
     onSubmitByMonthOld()
     {
        var year = this.myFormMonth.value.year;
         var month = this.myFormMonth.value.month;
         //console.log(Number(year),Number(month));
        this.shipments.snapshotChanges().subscribe((snapshot)=>{
          this.data = [];
          if(Number(year) > 0  && Number(month) > 0)
          {
            snapshot.forEach((element)=>{
              if(Number(year) == element.payload.child("source/date/year").val() && Number(month) == element.payload.child("source/date/month").val())
              {
                  var y = element.payload.toJSON();
                  y["$key"] = element.key;
                  y["branchName"] = this.branchArray?this.branchArray[element.payload.child("branch").val()].name:"";
                  this.data.push(y);
              }
              else if(Number(year) == element.payload.child("destination/date/year").val() && Number(month) == element.payload.child("destination/date/month").val())
              {
                var y = element.payload.toJSON();
                  y["$key"] = element.key;
                  y["branchName"] = this.branchArray?this.branchArray[element.payload.child("branch").val()]?this.branchArray[element.payload.child("branch").val()].name:"":"";
                  this.data.push(y);
              }
            });
            this.searchResult = this.data;
            this.loadItems();
          }
          else if(Number(month) == 0)
          {
            snapshot.forEach((element)=>{
              if(Number(year) == element.payload.child("source/date/year").val() || Number(year) == element.payload.child("destination/date/year").val())
              {
                  var y = element.payload.toJSON();
                  y["$key"] = element.key;
                  y["branchName"] = this.branchArray?this.branchArray[element.payload.child("branch").val()]?this.branchArray[element.payload.child("branch").val()].name:"":"";
                  this.data.push(y);
              }
            });
            this.searchResult = this.data;
            this.loadItems();
          }
        });
      }
      onSubmitByMonth()
     {
        var year = this.myFormMonth.value.year;
        var month = this.myFormMonth.value.month;
        this.data = [];
          if(Number(year) > 0  && Number(month) > 0)
          {
            this.shipmentData.forEach(element=>{
              var sy = element.source.date?element.source.date.year:0;
              var sm = element.source.date?element.source.date.month:0;
              var dy = element.destination.date?element.destination.date.year:0;
              var dm = element.destination.date?element.destination.date.month:0;
              if(Number(year) == sy && Number(month) == sm)
              {
                  this.data.push(element);
              }
              else if(Number(year) == dy && Number(month) == dm)
              {
                  this.data.push(element);
              }
            });
            this.searchResult = this.data;
            this.loadItems();
          }
          else if(Number(month) == 0)
          {
            this.shipmentData.forEach(element=>{
              var sy = element.source.date?element.source.date.year:0;
              var dy = element.destination.date?element.destination.date.year:0;
              if(Number(year) == sy || Number(year) == dy)
              {
                  this.data.push(element);
              }
            });
            this.searchResult = this.data;
            this.loadItems();
          }
      }
      onStatusFilterSelectedOld(event)
      {
        var status = Number(event.target.value);
        this.shipments.snapshotChanges().subscribe((snapshot)=>{
          this.data = [];
            snapshot.forEach((element)=>{
              if(status == element.payload.child("status").val())
              {
                  var y = element.payload.toJSON();
                  y["$key"] = element.key;
                  if(element.payload.child("branch").val())
                  {
                    y["branchName"] = this.branchArray?this.branchArray[element.payload.child("branch").val()]?this.branchArray[element.payload.child("branch").val()].name:"":"";
                  }
                  this.data.push(y);
              }
            });
            this.searchResult = this.data;
            this.loadItems();
        });
      }
      onStatusFilterSelected(event)
      {
        this.searchSubmitted = true;
        var status = Number(event.target.value);
          this.data = [];
            this.shipmentData.forEach((element)=>{
              if(status == element.status)
              {
                  this.data.push(element);
              }
            });
            this.searchResult = this.data;
            this.loadItems();
            this.selectedStatus = status;
            if(this.isadmin && status == 11)
            {
              this.getBranchTransferredShipmentsForAdmin(this.ss.getUserBranch);
            }
      }
      getBranchTransferredShipmentsForAdmin(branch)
      {
        this.logisticsService.getBranchTransfferedOrders(branch).once("value").then((transferData)=>{
          this.searchResult = [];
          this.data = [];
          var transferOrderIdList = [];
          transferData.forEach(td=>{
            this.logisticsService.getShipmentsWithId(td.child("shipmentId").val()).once("value").then((element)=>{
              var y = element.val();
              y["$key"] = element.key;
              if(td.child("to").val())
              {
                y["branchName"] = this.branchArray?this.branchArray[td.child("to").val()]?this.branchArray[td.child("to").val()].name:"":"";
              }
              if(td.child("from").val())
              {
                y["fromBranchName"] = this.branchArray?this.branchArray[td.child("from").val()]?this.branchArray[td.child("from").val()].name:"":"";
              }
              if(element.child("items").val()!=null)
              {
                var items = element.child("items").val();
                var itemList = [];
                for(let i in items)
                {
                  itemList.push(items[i]);
                }
                y["itemList"] = itemList;
              }
              if(element.child("transitHistory").val()!=null)
              {
                var transitHistory = element.child("transitHistory").val();
                for(let i in transitHistory)
                {
                  if(transitHistory[i].status == "Shipment Pickedup")
                  y["pickedBy"] = transitHistory[i].userName;
                }
              }
              if(this.users)
              {
                if(element.child("assignedTo").val())
                y["assignee"] = this.users[element.child("assignedTo").val()];
                if(element.child("assignedPerson").val())
                y["assignee"] = element.child("assignedPerson").val();
              }
              y["statusText"] = this.getStatus(element.child("status").val());
              y["pickupDate"] ="ASAP";
              if(element.child("source/date").val())
              {
                var date = element.child("source/date").val();
                y["pickupDate"] = date.day+"/"+date.month+"/"+date.year;
              }
              y["deliveryDate"] ="ASAP";
              if(element.child("destination/date").val())
              {
                var date = element.child("destination/date").val();
                y["deliveryDate"] = date.day+"/"+date.month+"/"+date.year;
              }
              
              if(this.isadmin && td.child("to").val()!=null && td.child("to").val() == this.searchForm.value.toBranch)
              {
                //this.setFilterOnAdminBranchTransferList();
                if(this.searchForm.value.fromdate!=null && this.searchForm.value.todate!=null)
                {
                  //console.log("data here ",y["$key"],!(transferOrderIdList.includes(y["$key"])),transferOrderIdList);
                  var from = this.searchForm.value.fromdate;
                  var to = this.searchForm.value.todate;
                  var fromDate = from.day+"/"+from.month+"/"+from.year;
                  var toDate = to.day+"/"+to.month+"/"+to.year;
                  if(y["pickupDate"]!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,y["pickupDate"]) && !transferOrderIdList.includes(y["$key"]))
                  {
                      this.data.push(y);
                      this.searchResult.push(y);
                      transferOrderIdList.push(y["$key"]);
                  }
                  else if(y["deliveryDate"]!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,y["deliveryDate"]) && !transferOrderIdList.includes(y["$key"]))
                  {
                    this.data.push(y);
                    this.searchResult.push(y);
                    transferOrderIdList.push(y["$key"]);
                  }
                }
                else if(!transferOrderIdList.includes(y["$key"]))
                {
                  
                  this.searchResult.push(y);
                  this.data.push(y);
                  transferOrderIdList.push(y["$key"]);
                }
                this.loadItems();
              }
              else if(this.isadmin && this.searchForm.value.toBranch==null)
              {
                //console.log("admin to branch null");
                
                //this.setFilterOnAdminBranchTransferList();
                if(this.searchForm.value.fromdate!=null && this.searchForm.value.todate!=null)
                {
                  var from = this.searchForm.value.fromdate;
                  var to = this.searchForm.value.todate;
                  var fromDate = from.day+"/"+from.month+"/"+from.year;
                  var toDate = to.day+"/"+to.month+"/"+to.year;
                  if(y["pickupDate"]!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,y["pickupDate"]) && !transferOrderIdList.includes(y["$key"]))
                  {
                      this.data.push(y);
                      this.searchResult.push(y);
                      transferOrderIdList.push(y["$key"]);
                  }
                  else if(y["deliveryDate"]!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,y["deliveryDate"]) && !transferOrderIdList.includes(y["$key"]))
                  {
                    this.data.push(y);
                    this.searchResult.push(y);
                    transferOrderIdList.push(y["$key"]);
                  }
                }
                else if(!transferOrderIdList.includes(y["$key"]))
                {
                  this.searchResult.push(y);
                  this.data.push(y);
                  transferOrderIdList.push(y["$key"]);
                }
                this.loadItems();
              }
              else if(!this.isadmin && td.child("to").val()!=null && td.child("to").val() == this.searchForm.value.toBranch)
              {
                
                //this.setFilterOnAdminBranchTransferList();
                if(this.searchForm.value.fromdate!=null && this.searchForm.value.todate!=null)
                {
                  var from = this.searchForm.value.fromdate;
                  var to = this.searchForm.value.todate;
                  var fromDate = from.day+"/"+from.month+"/"+from.year;
                  var toDate = to.day+"/"+to.month+"/"+to.year;
                  if(y["pickupDate"]!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,y["pickupDate"]) && !transferOrderIdList.includes(y["$key"]))
                  {
                      this.data.push(y);
                      this.searchResult.push(y);
                      transferOrderIdList.push(y["$key"]);
                  }
                  else if(y["deliveryDate"]!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,y["deliveryDate"]) && !transferOrderIdList.includes(y["$key"]))
                  {
                    this.data.push(y);
                    this.searchResult.push(y);
                    transferOrderIdList.push(y["$key"]);
                  }
                }
                else if(!transferOrderIdList.includes(y["$key"]))
                {
                  this.searchResult.push(y);
                  this.data.push(y);
                  transferOrderIdList.push(y["$key"]);
                }
                this.loadItems();
              }
              else if(!this.isadmin && this.searchForm.value.toBranch==null)
              {
                //this.setFilterOnAdminBranchTransferList();
                if(this.searchForm.value.fromdate!=null && this.searchForm.value.todate!=null)
                {
                  var from = this.searchForm.value.fromdate;
                  var to = this.searchForm.value.todate;
                  var fromDate = from.day+"/"+from.month+"/"+from.year;
                  var toDate = to.day+"/"+to.month+"/"+to.year;
                  if(y["pickupDate"]!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,y["pickupDate"]) && !transferOrderIdList.includes(y["$key"]))
                  {
                      this.data.push(y);
                      this.searchResult.push(y);
                      transferOrderIdList.push(y["$key"]);
                  }
                  else if(y["deliveryDate"]!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,y["deliveryDate"]) && !transferOrderIdList.includes(y["$key"]))
                  {
                    this.data.push(y);
                    this.searchResult.push(y);
                    transferOrderIdList.push(y["$key"]);
                  }
                }
                else if(!transferOrderIdList.includes(y["$key"]))
                {
                  this.searchResult.push(y);
                  this.data.push(y);
                  transferOrderIdList.push(y["$key"]);
                }
                this.loadItems();
              }
              });
              });
        });
      }
      setFilterOnAdminBranchTransferList()
      {
        var result = [];
        var status = this.searchForm.value.status?this.getStatus(Number(this.searchForm.value.status)):"";
        var assignee = this.searchForm.value.assignee?this.searchForm.value.assignee:"";
        var branch = this.searchForm.value.branch?this.searchForm.value.branch:"";
        var phoneNumber = this.searchForm.value.phoneNumber?this.searchForm.value.phoneNumber:"";
        result = filterBy(this.data, {
          logic: 'and',
          filters: [{ field: "source.phoneNumber", operator: "contains", value: phoneNumber},
                    { field: "branch", operator: "contains", value: branch},
                    { field: "assignee", operator: "contains", value: assignee},
                    { field: "statusText", operator: "contains", value: status}]});
        this.data = result;
        if(this.searchForm.value.fromdate!=null && this.searchForm.value.todate!=null)
        {
          this.data = [];
          result.forEach(r=>{
            var from = this.searchForm.value.fromdate;
            var to = this.searchForm.value.todate;
            var fromDate = from.day+"/"+from.month+"/"+from.year;
            var toDate = to.day+"/"+to.month+"/"+to.year;
            if(r.pickupDate!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,r.pickupDate))
            {
                this.data.push(r);
            }
            else if(r.deliveryDate!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,r.deliveryDate))
            {
              this.data.push(r);
            }
          });
          this.loadItems();
        }
        this.loadItems();
      }
  alertDialog()
  {
    swal({
      title: 'Change Branch?',
      text: "Branch can't be changed now!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#834495',
      cancelButtonColor: '#868e96',
      confirmButtonText: 'Proceed'
    }).then(() => {
    }).catch(swal.noop);
  }
  outForDelivery(shipmentId)
  {
    //console.log("outForDelivery",shipmentId);
    this.logisticsService.outForDeliveryAssignDeliveryBoy(shipmentId);
  }
  outForTransferShipmentId:any;
  outForTransferShipmentBranch:any;
  outForTransfer(shipmentId,shipmentBranch,event)
    {
      this.outForTransferShipmentId = shipmentId;
      this.outForTransferShipmentBranch = shipmentBranch;
      document.querySelector("#" + event).classList.add('md-show');
    }

getUserDetails()
  {
    firebase.database().ref("users").child(localStorage.getItem("courierapp_user_id")).once("value",(user)=>{
      this.user = user.val();
    });
  }
  onSubmitBranch()
  {
    var event = 'effect-1';
    //console.log("myFormBranch onSubmitBranch");
    if(this.myFormBranch.valid)
    {
      //console.log("myFormBranch",this.myFormBranch.value.branch);
      document.querySelector("#" + event).classList.remove('md-show');
      var branch = this.myFormBranch.value.branch;
      var date_time = this.dateService.getTimeandDate();
      this.logisticsService.transferOrder(branch,this.outForTransferShipmentId,this.user,this.outForTransferShipmentBranch,date_time)
    }
  }
  closeMyModal(event) {
    var events = 'effect-1';
    document.querySelector("#" + events).classList.remove('md-show');
    ((event.target.parentElement.parentElement).parentElement).classList.remove('md-show');
  }
  getSettings()
  {
    firebase.database().ref("settings").child("shipment").once("value").then((data)=>{
      if(data.child("routing").val() == 'Auto')
      {
        this.isAuto = true;
      }
      else
      {
        this.isAuto = false;
      }
    });
  }
  getAllUsers()
  {
    this.us.getAllUser().snapshotChanges().subscribe((data)=>{
      this.users = [];
      data.forEach(d=>{
        var fn = d.payload.child("firstName").val();
        var ln = d.payload.child("lastName").val();
        this.users[d.key] = fn+" "+ln;
      });
    });
  }
  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadItems();
    curentPage.page = this.skip;
  }

  generateArray(obj){
    return Object.keys(obj).map((key)=>{ return obj[key]});
 }
 
  private loadItems():void{
    var statustextName = '';
    this.gridDataToPdf = [];
    this.gridDataToPdfExport = [];
    for(let i=0;i<this.data.length;i++) {
      if(this.data[i].source.date) {
        this.data[i].source.fullDate = parseInt(this.data[i].source.date.day) + '/' + parseInt(this.data[i].source.date.month) + '/' + parseInt(this.data[i].source.date.year);
      }
      if(this.data[i].destination.date) {
        this.data[i].destination.fullDate = parseInt(this.data[i].destination.date.day) + '/' + parseInt(this.data[i].destination.date.month) + '/' + parseInt(this.data[i].destination.date.year);
      }
      if(this.data[i].items) {
        this.data[i].items.quantity = parseInt(this.data[i].items["0"].quantity);
      }
      if(this.data[i].status){
        switch(this.data[i].status) {
          case 0 : {
            statustextName = 'Ordered';
            break;
          }
          case 1 : {
            statustextName = 'Accepted';
            break;
          }
          case 2 : {
            statustextName = 'Declined';
            break;
          }
          case 3 : {
            statustextName = 'Supervision';
            break;
          }
          case 4 : {
            statustextName = 'Estimated';
            break;
          }
          case 5 : {
            statustextName = 'Approved';
            break;
          }
          case 6 : {
            statustextName = 'Assigned';
            break;
          }
          case 7 : {
            statustextName = 'Picked-up';
            break;
          }
          case 8 : {
            statustextName = 'Dropped';
            break;
          }
          case 9 : {
            statustextName = 'Delivered';
            break;
          }
          case 10 : {
            statustextName = 'Declined';
            break;
          }
          case 11 : {
            statustextName = 'Branch Transfer';
            break;
          }
          
        }
        this.data[i].excelStatus=statustextName;
      }
     
      if(this.data[i].transitHistory){
        let a=this.generateArray(this.data[i].transitHistory);
        a.forEach(element => {
          if(element.status==="Shipment Delivered") {
            this.data[i].deliveredBy = element.userName;
          }
        })
      }

      

    }


    this.gridDataToPdf = this.data;
    this.pageSizeExcel = this.data.length;
    this.gridDataToPdfExport = this.data;

    this.gridView = {
      data: orderBy(this.data,this.sort).slice(this.skip, this.skip + this.pageSize),
      total: this.data.length
    };
  }
  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.loadItems();
}
onSubmitByDriver()
{
  var result = [];
  this.data = this.shipmentData;
  if(this.myFormDriver.valid)
  {
    result = filterBy(this.data, {
      logic: 'and',
      filters: [
          { field: "assignedTo", operator: "eq", value: this.myFormDriver.value.driver},
          { field: "branch", operator: "eq", value: this.myFormDriver.value.branch}]});
  }
  else if(this.myFormDriver.value.driver == null && this.myFormDriver.value.branch != null)
  {
    result = filterBy(this.data, {
      logic: 'or',
      filters: [{ field: "branch", operator: "eq", value: this.myFormDriver.value.branch}]});
  }
  else if(this.myFormDriver.value.driver != null && this.myFormDriver.value.branch == null)
  {
    result = filterBy(this.data, {
      logic: 'or',
      filters: [{ field: "assignedTo", operator: "eq", value: this.myFormDriver.value.driver}]});
  }
  this.data =  result;
  this.searchResult = this.data;
  this.loadItems();
}
wayBill(id)
{
  window.open("http://paarsel.com/inv/"+id, '_blank');
}
onChangeFilter()
{
    //console.log("data and search result ",this.data,this.searchResult,this.shipmentData);
    if(!this.searchSubmitted)
    {
      this.data = this.shipmentData;
    }
    else
    {
      this.data = this.searchResult;
    }
    this.data = filterBy(this.data, {
      logic: 'or',
      filters: [{ field: "id", operator: "contains", value: this.filterQuery},
                { field: "source.phoneNumber", operator: "contains", value: this.filterQuery},
                // { field: "source.name", operator: "contains", value: this.filterQuery},
                //{ field: "destination.name", operator: "contains", value: this.filterQuery},
                { field: "branchName", operator: "contains", value: this.filterQuery},
                { field: "assignee", operator: "contains", value: this.filterQuery},
                { field: "statusText", operator: "contains", value: this.filterQuery}]});
    this.loadItems();
}
getStatus(statusValue)
{
  var status;
  switch(statusValue)
  {
    case 0: status = "ordered";
    break;
    case 1: status = "accepted";
    break;
    case 2: status = "declined";
    break;
    case 6: status = "assigned";
    break;
    case 7: status = "pickedup";
    break;
    case 8: status = "dropped";
    break;
    case 9: status = "delivered";
    break;
    case 10: status = "declined";
    break;
    case 11: status = "branch transfer";
    break;
  }
  return status;
}
onSubmitByBranchTransfer()
{
  if(this.myFormBranchTransfer.valid)
  {
  this.getBranchTransferredShipmentsForAdmin(this.myFormBranchTransfer.value.fromBranch);
  }
}
testFilter()
{
  var result = [];
  var status = null;
  result = filterBy(this.shipmentData, {
    logic: 'and',
    filters: [{ field: "id", operator: "contains", value: ""},
              { field: "source.phoneNumber", operator: "contains", value: ""},
              { field: "branchName", operator: "contains", value: "mangalore"},
              { field: "assignee", operator: "contains", value: "Aysha"},
              { field: "statusText", operator: "contains", value: status?status:""}]});
  this.data = result;
  if(this.myForm.valid)
  {
    this.data = [];
    result.forEach(r=>{
      var from = this.myForm.value.fromdate;
      var to = this.myForm.value.todate;
      var fromDate = from.day+"/"+from.month+"/"+from.year;
      var toDate = to.day+"/"+to.month+"/"+to.year;
      if(r.pickupDate!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,r.pickupDate))
      {
          this.data.push(r);
      }
      else if(r.deliveryDate!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,r.deliveryDate))
      {
        this.data.push(r);
      }
    });
    this.loadItems();
  }
  this.loadItems();
}

searchFilter()
{
  this.searchSubmitted = true;
  var result = [];
  var status = this.searchForm.value.status?this.getStatus(Number(this.searchForm.value.status)):"";
  var assignee = this.searchForm.value.assignee?this.searchForm.value.assignee:"";
  var branch = this.searchForm.value.branch?this.searchForm.value.branch:"";
  var phoneNumber = this.searchForm.value.phoneNumber?this.searchForm.value.phoneNumber:"";
  var fromBranch = this.searchForm.value.fromBranch?this.searchForm.value.fromBranch:"";
  var toBranch = this.searchForm.value.toBranch?this.searchForm.value.toBranch:"";
  if(this.isadmin && status == "branch transfer")
  {
    //console.log("admin",toBranch);
    this.getBranchTransferredShipmentsForAdmin(this.ss.getUserBranch);
  }
  else if(!this.isadmin && status == "branch transfer" && fromBranch!="")
  {
    //console.log("super admin",fromBranch);
    this.getBranchTransferredShipmentsForAdmin(fromBranch);
  }
  else
  {
    result = filterBy(this.shipmentData, {
      logic: 'and',
      filters: [{ field: "source.phoneNumber", operator: "contains", value: phoneNumber},
                { field: "branch", operator: "contains", value: branch},
                { field: "assignee", operator: "contains", value: assignee},
                { field: "statusText", operator: "contains", value: status}]});
    this.data = result;
    if(this.searchForm.value.fromdate!=null && this.searchForm.value.todate!=null)
    {
      this.data = [];
      result.forEach(r=>{
        var from = this.searchForm.value.fromdate;
        var to = this.searchForm.value.todate;
        var fromDate = from.day+"/"+from.month+"/"+from.year;
        var toDate = to.day+"/"+to.month+"/"+to.year;
        if(r.pickupDate!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,r.pickupDate))
        {
            this.data.push(r);
        }
        else if(r.deliveryDate!= "ASAP" && this.dateService.checkDatesFromToRange(fromDate,toDate,r.deliveryDate))
        {
          this.data.push(r);
        }
      });
      this.loadItems();
    }
    this.loadItems();
  }
}

public onExcelExport(e: any): void{
  //let workbook = e.workbook;
  //this.gridDataToPdf[0].source.fullDate;
   const rows=[];
   rows.push({
    cells: <WorkbookSheetRowCell[]>[
        { value: 'Waybill No.' },
        { value: 'Pickup Date' },
        { value: 'Picked By' },
        { value: 'Shipper Name' },
        { value: 'Shipper Mobile' },
        { value: 'Shipper City' },
        { value: 'Qty' },
        { value: 'Receiver Name' },
        { value: 'Receiver Mob' },
        { value: 'Receiver city' },
        { value: 'Status' },
        { value: 'Delivery By' },
        { value: 'Delivery Date' },
        { value: 'Total Amount' }
    ]
   });
   this.gridDataToPdf.forEach(element => {
    rows.push({
      cells: <WorkbookSheetRowCell[]>[
          // First cell
          { value: element.id },
          { value: element.pickupDate },
          { value: element.pickedBy },
          { value: element.source.name },
          { value: element.source.phoneNumber },
          { value: element.source.city },
          { value: (element.items?element.items[0].quantity:0) },
          { value: element.destination.name },
          { value: element.destination.phoneNumber },
          { value: element.destination.city },
          { value: element.excelStatus },
          { value: element.deliveredBy },
          { value: element.deliveryDate },
          { value: element.total }
          
      ]
     });
   });


   
    const workbook = new Workbook({
    sheets: <WorkbookSheet[]>[
        {
            // Column settings (width)
            columns: <WorkbookSheetColumn[]>[
                { autoWidth: true },
                { autoWidth: true }
            ],
            // Title of the sheet
            name: 'Customers',
            // Rows of the sheet
            rows: rows
        }
    ]
});

workbook.toDataURL().then(dataUrl => {
  saveAs(dataUrl, 'Test.xlsx');
});

}

restorePageOnSearch()
{
  //console.log("restore", form_date,curentPage.page);
  this.skip = curentPage.page;
  this.loadItems();
  /* if(form_date)
  {
    this.getSpecificDateShipment(form_date.from,form_date.to);
    this.searchSubmitted =  true;
  } */
}
  receiveMessage($event) {
    curentTab.tab = $event;
  }
  onTabSelected(tab)
  {
    curentTab.tab = tab;
    this.tabRef.activeId = curentTab.tab;
    console.log("tab",tab);
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/manage-shipment/manage-shipment.component.ts